import { render, staticRenderFns } from "./CoursesSettings.vue?vue&type=template&id=78e6ce58&scoped=true&lang=pug&"
import script from "./CoursesSettings.vue?vue&type=script&lang=ts&"
export * from "./CoursesSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesSettings.vue?vue&type=style&index=0&id=78e6ce58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e6ce58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
